import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { PublicLayout } from '../components/PublicLayout';
import { buttonVariants } from '../components/ui/button';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <PublicLayout title={t('notFound.title')}>
      <Link to="/" className={buttonVariants({ variant: 'secondary' })}>
        {t('notFound.home')}
      </Link>
    </PublicLayout>
  );
}
